import { createSelector } from 'reselect';

const selecLibrary = (state: any) => state.library;

export const selectCurrentItem = createSelector([selecLibrary], (library) => library.current);

export const selectListItems = createSelector([selecLibrary], (library) => library.read);

export const selectSearchedItems = createSelector([selecLibrary], (library) => library.search);

export const selectItemsCount = createSelector([selecLibrary], (library) => library.count);

export const selectItemsFilter = createSelector([selecLibrary], (library) => library.filter);